let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ipU1p")).then(() => parcelRequire('iSy9M'));